import { gatewayInstance } from "../../axiosInstance";

export const exchangeRteById = async (id) => {
  try {
    console.log("response");
    console.log(id);
    const response = await gatewayInstance.get(
      `/financeservice/exchangeRate/${id}`,
    );

    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const addExchangeRate = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/exchangeRate",
      data,
    );
  } catch (e) {
    console.error(e);
  }
};
export const updateExchangeRate = async (data) => {
  try {
    return await gatewayInstance.put("/financeservice/exchangeRate", data);
  } catch (e) {
    console.error(e);
  }
};

export const searchExchangeRates = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/exchangeRate/search",
      data,
    );
    console.log(response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const exchangeRateSearchDropdown = async ({
  searchText,
  bank = null,
  branch = null,
}) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/exchangeRate/search-dropdown",
      { search: searchText, bank, branch },
    );
    return response.data.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};
